import React from "react"

import { AuthorizationError } from "./AuthorizationError"
import ErrorBoundary from "./ErrorBoundary"

export default class AuthorizationErrorBoundary extends ErrorBoundary {
	protected captureError = false

	static getDerivedStateFromError(error: Error) {
		return {
			hasError: error instanceof AuthorizationError,
		}
	}

	public canHandleError(error: Error): boolean {
		return error instanceof AuthorizationError
	}

	public renderOnError():
		| React.ReactElement<any, string | React.JSXElementConstructor<any>>
		| string
		| number
		| {}
		| React.ReactNodeArray
		| React.ReactPortal
		| boolean
		| null
		| undefined {
		return <>Unauthorized Access.</>
	}
}
